import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { ProductProvider } from "./contexts/ProductContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import NotFound from "pages/NotFound";
import ProductCatalogManagement from './pages/product-catalog-management';
import QuoteEditorInterface from './pages/quote-editor-interface';
import CustomerQuoteReviewPortal from './pages/customer-quote-review-portal';
import QuotesOverviewDashboard from './pages/quotes-overview-dashboard';
import CustomerManagementDashboard from './pages/customer-management-dashboard';
import CustomerProfileEditor from './pages/customer-profile-editor';
import CustomersManagementPage from './pages/customers-management-page';
import UserAuthenticationLogin from './pages/user-authentication-login';
import UserManagementDashboard from './pages/user-management-dashboard';
import QuoteActivityAuditDashboard from './pages/quote-activity-audit-dashboard';
import PasswordResetRequest from './pages/password-reset-request';
import PasswordResetConfirmation from './pages/password-reset-confirmation';
import AccountSettingsPasswordManagement from './pages/account-settings-password-management';

export default function Routes() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProductProvider>
          <ErrorBoundary>
            <ScrollToTop />
            <RouterRoutes>
              {/* Public Routes */}
              <Route path="/user-authentication-login" element={<UserAuthenticationLogin />} />
              <Route path="/password-reset-request" element={<PasswordResetRequest />} />
              <Route path="/auth/reset" element={<PasswordResetConfirmation />} />
              <Route path="/customer-quote-review-portal/:id" element={<CustomerQuoteReviewPortal />} />
              
              {/* Protected Routes - All require authentication except customer portal */}
              <Route path="/" element={<ProtectedRoute><QuotesOverviewDashboard /></ProtectedRoute>} />
              <Route path="/product-catalog-management" element={<ProtectedRoute><ProductCatalogManagement /></ProtectedRoute>} />
              <Route path="/quote-editor-interface" element={<ProtectedRoute><QuoteEditorInterface /></ProtectedRoute>} />
              <Route path="/quote-editor-interface/:id" element={<ProtectedRoute><QuoteEditorInterface /></ProtectedRoute>} />
              <Route path="/customer-management-dashboard" element={<ProtectedRoute><CustomerManagementDashboard /></ProtectedRoute>} />
              <Route path="/customer-profile-editor" element={<ProtectedRoute><CustomerProfileEditor /></ProtectedRoute>} />
              <Route path="/customer-profile-editor/:id" element={<ProtectedRoute><CustomerProfileEditor /></ProtectedRoute>} />
              <Route path="/quotes-overview-dashboard" element={<ProtectedRoute><QuotesOverviewDashboard /></ProtectedRoute>} />
              <Route path="/customers-management-page" element={<ProtectedRoute><CustomersManagementPage /></ProtectedRoute>} />
              <Route path="/account-settings-password-management" element={<ProtectedRoute><AccountSettingsPasswordManagement /></ProtectedRoute>} />
              
              {/* Admin-Only Routes */}
              <Route path="/user-management-dashboard" element={<ProtectedRoute requireAdmin={true}><UserManagementDashboard /></ProtectedRoute>} />
              
              <Route
                path="/quote-activity-audit-dashboard"
                element={
                  <ProtectedRoute>
                    <QuoteActivityAuditDashboard />
                  </ProtectedRoute>
                }
              />
              
              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </ErrorBoundary>
        </ProductProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}